export default {
  ONCE: "1nce",
  LIONEL: "lionel"
};
